/**
 * ApiValidationHandler class.
 *
 * @class
 *
 * @description Handles validation responses from APIs.
 */
export default class ApiValidationHandler {
    /**
     * Error bag.
     *
     * @var {Object}
     */
    errors = {};

    /**
     * ApiValidationHandler constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.errors = {};
    }

    /**
     * Clear all error fields.
     *
     * @returns {void}
     */
    clear() {
        this.errors = {};
    }

    /**
     * Retrieve the error for field.
     *
     * @param {Object} field
     *
     * @returns {Object|null}
     */
    get(field) {
        if (!this.has(field)) {
            return null;
        }

        return this.errors[field];
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {String} field
     *
     * @returns {Boolean}
     */
    has(field) {
        return Object.prototype.hasOwnProperty.call(this.errors, field);
    }

    /**
     * Record new errors.
     *
     * @param {Object} errors
     *
     * @returns {void}
     */
    record(errors) {
        this.errors = errors;
    }
}
